module.exports = __webpack_public_path__ + "img/cognitive_img05.42ef8722.jpg";